import React from 'react';
import PropTypes from 'prop-types';
import { StyledProgressBar, StyledProgressWrapper } from '../styles/ProgressBar.styles';
import SafeComponent from '../../../hoc/withErrorBoundary/errorBoundary';

const ProgressBar = ({ value, max }) => {
  return (
    <StyledProgressWrapper max={max}>
      <StyledProgressBar value={value} />
    </StyledProgressWrapper>
  );
};

export default SafeComponent(ProgressBar);

ProgressBar.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
};

ProgressBar.defaultProps = {
  value: 10,
  max: 100,
};
